module.exports = __webpack_public_path__ + "static/media/BagelCompanyImage.c9f8c040.svg";